module.exports = __webpack_public_path__ + "static/media/eh.47462aec.svg";